"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextTool = void 0;
const fabric_with_gestures_1 = require("fabric-with-gestures");
const genericTool_1 = require("./genericTool");
const textToolOptions_1 = require("./options/textToolOptions");
class TextTool extends genericTool_1.GenericTool {
    constructor(options) {
        super(textToolOptions_1.textToolOptions, options);
    }
    activate(annotator) {
        super.activate(annotator);
    }
    onMouseUp() {
        const pointer = this.annotator.canvas.getPointer(null);
        const bounds = { left: null, top: null, width: null };
        if (this.initialPosition.x > pointer.x) {
            bounds.left = pointer.x;
            bounds.width = this.initialPosition.x - pointer.x;
        }
        else {
            bounds.left = this.initialPosition.x;
            bounds.width = pointer.x - this.initialPosition.x;
        }
        if (this.initialPosition.y > pointer.y) {
            bounds.top = pointer.y;
        }
        else {
            bounds.top = this.initialPosition.y;
        }
        this.annotation = new fabric_with_gestures_1.fabric.Textbox('', {
            ...bounds,
            fontFamily: this.options.fontFamily,
            fontSize: this.options.fontSize,
            fill: this.options.color,
            backgroundColor: this.options.backgroundColor
        });
        if (this.annotation && this.annotation.width != 0) {
            this.annotator.canvas.add(this.annotation);
            this.annotation.enterEditing();
            return true;
        }
        else {
            return false;
        }
    }
    ;
}
exports.TextTool = TextTool;
